import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { FooterMenu } from "@qivia/ui";
import { Page } from "@qivia/ui/src/designSystem/components/driverAppV2/Page";
import {
  AccountBalanceOutlined,
  ArticleOutlined,
  CallOutlined,
  CreditCardOutlined,
  DirectionsCarOutlined,
  HomeOutlined,
  PersonOutlined,
} from "@qivia/ui/src/designSystem/materialUi/materialUi";
import { isAppV2Enabled } from "./appV2Access";

type Tab = {
  path: string;
  labelKey: string;
  titleKey: string;
  icon: ReactNode;
};

const TABS: Tab[] = [
  {
    path: "/home",
    labelKey: "appV2.footerMenu.home",
    titleKey: "appV2.home.title",
    icon: <HomeOutlined />,
  },
  {
    path: "/refunds",
    labelKey: "appV2.footerMenu.refunds",
    titleKey: "appV2.refunds.title",
    icon: <AccountBalanceOutlined />,
  },
  {
    path: "/operations",
    labelKey: "appV2.footerMenu.operations",
    titleKey: "appV2.operations.title",
    icon: <ArticleOutlined />,
  },
  {
    path: "/vehicle",
    labelKey: "appV2.footerMenu.vehicle",
    titleKey: "appV2.vehicle.title",
    icon: <DirectionsCarOutlined />,
  },
  {
    path: "/profile",
    labelKey: "appV2.footerMenu.profile",
    titleKey: "appV2.profile.title",
    icon: <PersonOutlined />,
  },
];

export const AppV2Layout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (!isAppV2Enabled) return <Navigate to="/menu" replace />;

  const items = TABS.map((tab) => ({
    label: t(tab.labelKey),
    icon: tab.icon,
    isSelected: pathname === tab.path,
    onClick: () => navigate(tab.path),
  }));

  const current = TABS.find((tab) => tab.path === pathname);

  const topActions = [
    {
      label: t("appV2.header.card"),
      icon: <CreditCardOutlined />,
      onClick: () => navigate("/menu"),
    },
    {
      label: t("appV2.header.support"),
      icon: <CallOutlined />,
      onClick: () => navigate("/help"),
    },
  ];

  return (
    <Page
      title={current ? t(current.titleKey) : undefined}
      topActions={topActions}
      footerMenu={<FooterMenu items={items} />}
    >
      <Outlet />
    </Page>
  );
};
